












import { Vue, Component, Prop } from "vue-property-decorator";
import * as images from "../assets/images";
import * as signature from "../assets/signature";
//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component
export default class PDFPreview extends Vue {
  private nomeAllievo: string;
  private firma: string;

  constructor() {
    super();
    this.nomeAllievo = "Prova";
    this.firma = ""
  }

  saveSignature(){
    //@ts-ignore
        const signatureTutore = this.$refs.tutoreSignaturePad.saveSignature()
        this.firma = signatureTutore.data
       
  }

  downloadTest() {
    var dd = {
      /**--------------------------------------------------------
         * Le immagini di header e footer sono convertite in Base64
         * ed importate dal file Header_Footer.js
         ----------------------------------------------------------*/
      pageSize: "A4",
      // ****** FOOTER *********//
      footer: function(/*currentPage, pageCount*/) {
        return [
          {
            image: images.authFooter,
            width: "560",
            height: "80",
            margin: [20, 0]
          }
        ];
      },
      // ******** HEADER ******** //
      header: function(/*currentPage, pageCount, pageSize*/) {
        // you can apply any logic and return any valid pdfmake element

        return [
          {
            // image: images.authHeader,
            image: images.authHeader,
            width: "525",
            height: "90",
            margin: [35, 0]
          }
        ];
      },

      //******** TESTO DEL DOCUMENTO  ********/
      content: [
        {
          text:
            "Il modulo riguarda gli studenti frequentanti il Terzo o Quarto Anno di Corso interessati a svolgere stage estivo in azienda.",
          margin: [0, 70, 0, 5]
        },

        {
          text:
            "Per la compilazione serve la compresenza dello studente e dell'esercente la sua patria potestà. Per l'adesione occorre declinare le proprie generalità, dichiarare l'accettazione del regolamento inoltrato alle famiglie con circolare FEBB 2019 e sottoscrivere il modulo da entrambi i dichiaranti. Con la firma l'esercente la patria potestà autorizza lo studente alla partecipazione all'attività in oggetto.",
          alignment: "justify"
        },
        { text: "Generalità studente/ssa", style: "title" },
        {
          table: {
            widths: [100, "*"],
            body: [
              ["Cognome: ", "Cognome utente"],
              ["Nome: ", "Nome utente"],
              ["Nato/a a: ", "Luogo di nascita"],
              ["Nato/a il: ", "Data di nascita"],
              ["Indirizzo di residenza: ", "Indirizzo"],
              ["CAP: ", "CAP"],
              ["Telefono: ", "Tel."],
              ["e-mail istituzionale", "email"],
              ["Classe", "Classe"],
              ["Settore", "Sett"]
            ]
          },
          margin: [0, 0, 0, 10]
        },
        {
          text: "Generalità esercente la patria potestà",
          style: "title",
          margin: [0, 0, 0, 5]
        },
        {
          table: {
            widths: [100, "*"],
            body: [
              ["Cognome: ", ""],
              ["Nome: ", ""],
              ["Relazione parentale: ", ""],
              ["Indirizzo di residenza: ", ""],
              ["CAP: ", ""],
              ["Telefono: ", ""]
            ]
          },
          margin: [0, 0, 0, 10],
          pageBreak: "after"
        },
        { text: "DICHIARAZIONE", style: "title", margin: [0, 70, 0, 5] },
        {
          text: "Lo studente e l'esercente la sua patria potestà dichiarano:",
          style: { bold: true },
          margin: [0, 0, 0, 5]
        },
        {
          ul: [
            {
              text:
                "di essere interessati all'attività di stage nel periodo di sospensione delle lezioni;",
              margin: [0, 0, 0, 5]
            },
            "di aver preso visione, di condividere in solido e di accettare quanto riportato sulla \"Scheda di presentazione e Regolamento per l'accesso\" inoltrata alle famiglie con Circolare di FEBB 2019 e reperibile sul sito d'Istituto alla pagina Ampliamento offerta / Tirocini Aziendali."
          ],
          margin: [0, 0, 0, 5]
        },
        {
          text: "Firma Studente",
          margin: [0, 0, 0, 5]
        },
        {
          text: "Firma Esercente Patria Potestà",
          margin: [0, 0, 0, 5]
        },
        {
          image: this.firma,
          width: "100",
          margin: [0, 0, 0, 5]
        },
        {
          text: "Tsto di prova"
        }
        // {
        //     image: signature.firmaStudente,
        //     width: "150",
        //     height: "60",
        //     margin: [10, 60]
        // },
        // {
        //     text: "Firma Esercente Patria Potestà"
        // }
        // ,
        // {
        //     image: signature.firmaStudente,
        //     width: "150",
        //     height: "60",
        //     margin: [10, 60]
        // }
      ],

      styles: {
        header: {
          justified: true
        },
        title: {
          fontSize: 15,
          bold: true
        }
      }
    };
    // pdfMake.createPdf(dd).download("prova.pdf");
    pdfMake.createPdf(dd).open();
  }
}
